import { ___, partialApply } from '@ipfabric/utils/fp/partialApply';
import { uncollapseNodes } from 'components/Graph/commands/collapsing/helpers/uncollapseNodes';
import { deselectAllNodes } from 'components/Graph/commands/deselectAllNodes';
import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { isCollapsedNodeId } from 'components/Graph/model/GraphData';
import { selectAllEdgesSettings } from 'components/Graph/model/selectors/selectAllEdgesSettings';
import { set } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { createNodeCollapsingUndoableAction } from './helpers/createNodeCollapsingUndoableAction';

export const uncollapseSelectedNodes: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const originalGraph = cmdContext.getState().graph;
    const selectedGroupIds = pipe(
      originalGraph.selectedNodeIds,
      set.filter(isCollapsedNodeId(originalGraph.collapsedNodeGroups)),
    );
    dispatch(deselectAllNodes);
    dispatch(
      performUndoableAction,
      createNodeCollapsingUndoableAction(
        cmdContext.updateState,
        originalGraph,
        partialApply(
          uncollapseNodes,
          ___,
          selectAllEdgesSettings(cmdContext.getState()),
          selectedGroupIds,
        ),
      ),
    );
  };
